module.exports = __webpack_public_path__ + "img/blue.5fc9e66d.svg";